import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { makeStyles, Theme } from '@material-ui/core'
import React, { FC, Fragment } from 'react'

import { NonMSSubPropertyType } from '../nonMSTypes'
import NonMSOptionGroupSection from './NonMSOptionGroupSection'

const useStyles = makeStyles((theme: Theme) => ({
    subPropertyContainer: {
        display: 'flex',
        width: 'inherit',
        height: 'auto',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginLeft: theme.spacing(1),
    },
}))

interface SubPropertyProps {
    index: number
    subProperty: NonMSSubPropertyType
    propIndex: number
    propertyName: string
}

const NonMSSubPropertySection: FC<SubPropertyProps> = ({
    index,
    subProperty,
    propIndex,
    propertyName,
}) => {
    const classes = useStyles()

    return (
        <GridItem md={9}>
            <GridContainer className={classes.subPropertyContainer}>
                {subProperty.optionGroups.length &&
                    subProperty.optionGroups.map(({ groupId }, groupIndex) => (
                        <Fragment key={groupId}>
                            <NonMSOptionGroupSection
                                propIndex={propIndex}
                                index={index}
                                subProperty={subProperty}
                                groupIndex={groupIndex}
                                propertyName={propertyName}
                            />
                        </Fragment>
                    ))}
            </GridContainer>
        </GridItem>
    )
}

export default NonMSSubPropertySection
